<div class="row">
    <div class="col-6">
        <label class="padded-top-gray-label"> Customer </label>
        <app-user-selector-dropdown
            [preSelectedUser]="selectedUser"
            [showCreateLeadBtn]="false"
            (userSelected)="customerSelected($event)"></app-user-selector-dropdown>
    </div>
    <div
        class="col-6 make-call-btn-holder"
        *ngIf="selectedUser?.mobile && twilioService.isDeviceReady">
        <label class="padded-top-gray-label">
            {{ selectedUser?.mobile ? selectedUser?.mobile : '' }}
        </label>
        <button
            class="btn-styled btn-styled--success"
            type="button"
            (click)="makeACallProspect()">
            <svg-icon
                src="assets/images/icon-phone-call.svg"
                svgClass="svg-icon"></svg-icon>
            Make a Call
        </button>
    </div>
</div>
<app-create-customer
    [form]="form"
    [selectedUser]="selectedUser"></app-create-customer>
